const defaultState = () => ({ integrations: [] });
export default defaultState;
